import React from 'react';
import ChrText from '../../../../generic/Form/Basic/ChrText';

const RegistrationInput = ({ label, value, valueSetter, fieldName, formGroupClass, errorFields }) => {
  return(
    <ChrText
      data={{ label, value, labelClass: "cui-required-field" }}
      onChange={ (_event, _childUId, childData) => valueSetter(childData.value) }
      formGroupClass={ formGroupClass }
      formControlClass={ errorFields.includes(fieldName) && 'border-danger' }
      ariaLabel={ label }
    />
  )

};

export default RegistrationInput;